import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { MeasureReference } from "src/app/domain/GS/measure-reference";
import { CoreData } from "src/app/tools/core-data/core-data";
import { LoadingTask } from "src/app/tools/ui/loading-task";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";
import { MoveDeposeZoneTerrainDto } from "./move-depose-zone.dto";
import { Temporal } from "@js-temporal/polyfill";

@Injectable({
    providedIn: 'root',
})
export class ZoneService extends BaseService {

    private serviceUrl = `${environment.GSPServiceBaseUrl}api/zoneterrain`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    moveZoneOnDate(zoneCode: string, date: Date) {
        this.loadingTask.activateLoading();
        let dto = new MoveDeposeZoneTerrainDto();
        dto.DeposeZoneTerrainCode = zoneCode;
        dto.Date = date.toJSON();
        return this.http.post(`${this.serviceUrl}/s2s/move`, dto, this.generateHeader()).pipe(
            catchError(this.handleError<any>('moveZoneOnDate(')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

}